// 职业测评信息
import React from 'react';
import { Button } from 'antd';

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetMessage from '../../widget/WidgetMessage';
import { AddLineButton } from '../../widget/WidgetButton';
import WidgetListVerticalTable from '../../widget/WidgetListVerticalTable';

class CareerEvaluationInfo extends React.Component 
{
    constructor(props)
    {
        super(props);

        const { item = {} } = props.location?.state || {}; 

        this.state = {
            basePath: Config.getBasePath(),
            sourcePath: Config.getSourcePath(),
            item:item,
            data:[],
            total:0,
            page:1,
            loading:false,
            pageSize:9
        }
    }

    componentDidMount()
    {
        const { item } = this.state;

        if( item && item.id )
        {
            item["isTest"] = true;

            this.setState({item:item});
        }

        this.loadData();
    }

    componentWillReceiveProps( nextProps )
    {
        const { item = {} } = nextProps.location?.state || {}; 

        if( item && item.id )
        {
            item["isTest"] = true;

            this.setState({item:item});
        }

        console.log(nextProps);
    }

    favor = ( type ) => {

    }

    loadData = () => {

        const { page=1 , pageSize=9, basePath } = this.state;

        let params = {
            page: page,
            records:pageSize,
        }

        this.setState({loading:true, page:page, pageSize:pageSize});

        const onLoadData = (result, params ) => {

            if( result.status===0 )
            {
                this.setState({data:result.results, total:result.total, loading:false});
            }
            else
            {
                WidgetMessage.error(result.message);
            }
        }

        WidgetAjax.ajax({url:basePath + "/career/test_list", params:params, callback:onLoadData}, this.props);

    }

    notify = (type, item) => {

        switch( type )
        {
            case "click":
            {
                this.props.history.push({pathname:"/home/career-evaluation-info/" + item.id , state:{item:item}});
                
                break;
            }
            case "test":
            {
                this.props.history.push({pathname:"/home/career-evaluation-test", state:{item:item}}); 
            }
        }
    }

    pageTurning = (page, pageSize) => {
        this.setState({page:page, pageSize:pageSize}, () => {
            this.loadData();
        })
    }



    render()
    {
        const { sourcePath, item, data, total, page, pageSize, loading } = this.state;

        return (
            <div className="sf-page" component-data="career-evaluation-info">
                <div className='sf-career-top' style={{minHeight:905}}>
                    <div className='sf-career-evaluation-info-body'>
                        <div className='sf-career-evaluation'>
                            <div className='sf-career-evaluation-title'>{item.title}</div>

                            <div className='sf-career-evaluation-item'>
                                <div className='sf-career-evaluation-completed'>{item.completed}</div>
                                <div className='sf-career-evaluation-duration'>共<span>{item.completed}</span>题，预计用时<span>{item.duration}</span></div>
                            </div>

                            <div className='sf-career-evaluation-content'>
                                <div className='sf-career-evaluation-icon'>
                                    <img src={require('./../../img/' + sourcePath + '/career/evaluation.png')} alt=""></img>
                                </div>
                                <div className='sf-career-evaluation-right' >
                                    <div className='sf-career-evaluation-description'>{item.description}</div>
                                    <div className='sf-career-evaluation-tooltip'>测评可多次使用，每次使用间隔为60天</div>
                                    <div className='sf-career-evaluation-operation'>
                                        {
                                            item.isFavor ? 
                                                <><AddLineButton icon={ sourcePath + "/career/favor"} text="取消收藏" onClick={() => {this.favor("0")}}> </AddLineButton></> 
                                                : <><AddLineButton icon={ sourcePath + "/career/favor-select"} text="加入收藏" onClick={() => {this.favor("1")}}></AddLineButton></>
                                        }
                                        {
                                            item.isTest ? 
                                                <> <Button className="sf-career-evaluation-test" onClick={ () => { this.notify("test", item) }}>开始测试</Button> </> 
                                                : <> <Button className="sf-career-evaluation-test" onClick={ () => { this.notify("report", item) }} >查看报告</Button> </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='sf-career-explore-recommend'>
                            <div className='sf-career-explore-title'>
                                <div className='sf-career-explore-title-body'>
                                    <img src={require('./../../img/' + sourcePath + '/career/recommend.png')} alt=""></img>
                                    <div className='sf-career-explore-title-now'>我还为您推荐了其它测试</div>
                                </div>
                            </div>

                            <div className='sf-career-explore-recommend-content'>
                                <WidgetListVerticalTable loading={loading} data={data} total={total} page={page} notify={this.notify} 
                                    pageTurning={this.pageTurning} pageSize={pageSize}></WidgetListVerticalTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
export default CareerEvaluationInfo;